import page from './index';

export default {
    path: '/home/tiger/profitLoss-history',
    meta: { titie: '止盈止损历史' },
    component: page,
}
